export default __webpack_public_path__ + "07670c9b3adda22d28852873df58285f.png";